module.exports = __webpack_public_path__ + "img/FCFE4BD9-E9BE-48DE-A196-38CAEC3DC7FA.3cb4706e.png";